export default "__VITE_ASSET__DiJfNh3b__"